import { gql } from "@apollo/client";

export const GET_EXPENSE = gql`
  query expense($expenseId: String!) {
    expense(expenseId: $expenseId) {
      assetType
      vehicle {
        id
        licencePlate
      }
      addon{
        id
        name
        displayName
      }
      expenseType
      authority
      itemType
      unit
      amountPerUnit
      cycle
      insuranceExpiryDate
      expenseDate
      fuelType
      fuelCardNumber
      vendor
      odometerReading
      fuelQuantity
      reference
      amount
      driver
      paymentMode
      document {
        documentName
        url
      }
      description
      branch{
        id
        name
      }
      vehicleEvent{
        id
        vehicle
        eventStartDateTime
        eventEndDateTime
        odometerReadingAtStart
        odometerReadingAtEnd
        odometerReadingAtStartImg
        odometerReadingAtEndImg
        isBillable
        usedBy
      }
    }
  }
`;

export const GET_VEHICLE_DASHBOARD_DATA = gql`
  query getVehicleDashboardData($vehicleId: String!) {
    getVehicleDashboardData(vehicleId: $vehicleId) {
      acquisitionCost
      acquisitionSource
      vehicleExpenses{
        fuelCost,
        fineCost,
        serviceCost,
        damageCost,
        insuranceCost,
        maintenanceCost
      }
      vehicleRevenue{
        totalEarnings
        totalRevenueLoss
        residualValue
        depreciationPercentage
        idleTotalLoss
        realizedRevenue
        totalVORDays
        vorLossAmount
        futureBookingRevenue
      }
      renewalAndReminders{
        motRenewalDate
        taxRenewalDate
        insuranceRenewalDate
        nextServiceDate
      }
    }
  }
`;